import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon_circleChevronUp",
  "use": "icon_circleChevronUp-usage",
  "viewBox": "0 0 28 28",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28 28\" id=\"icon_circleChevronUp\"><rect x=\"28\" y=\"28\" width=\"28\" height=\"28\" rx=\"14\" transform=\"rotate(-180 28 28)\" fill=\"#98A5AD\" /><path d=\"M14.518 9.836l5.934 5.934a.733.733 0 010 1.036l-.692.692a.733.733 0 01-1.035.001L14 12.797l-4.725 4.702a.733.733 0 01-1.035-.001l-.692-.692a.733.733 0 010-1.036l5.934-5.934a.733.733 0 011.036 0z\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol